import { jsx } from "panel";
export function template() {
  const { visibility } = this.state;
  const direction = this.attr(`direction`);
  return /* @__PURE__ */ jsx(
    "div",
    {
      sel: ".mp-drop-menu-body",
      attrs: {
        elref: `contentBody`
      },
      class: {
        [`is-direction-${direction}`]: true,
        [`is-${visibility}`]: true
      }
    },
    /* @__PURE__ */ jsx(
      "slot",
      {
        on: {
          close: (ev) => {
            ev.stopPropagation();
            this.close();
          }
        }
      }
    ),
    this.attr(`show-arrow`) && /* @__PURE__ */ jsx("div", { sel: ".mp-drop-menu-arrow" })
  );
}
